export default __webpack_public_path__ + "static/media/shop.2123e512.svg";